import { all, call, takeLatest, put, select } from 'redux-saga/effects'

import { showGenericMessage } from '../app/actions'
import * as actions from './actions'
import * as authActions from '../auth/actions'
import * as types from './constants'
import * as services from './services'
import { getCurrentAppData } from '../../utils/fractalApps'

export function * changeUserPhoto ({ payload }) {
  const { url, translation } = payload
  const { auth: { user } } = yield select()
  const oldUser = user
  const newUser = { ...oldUser, photo_url: url }

  const userFastUpdate = () => authActions.getMyDataSuccessful(newUser)
  const userFastRollback = () => authActions.getMyDataSuccessful(oldUser)

  try {
    yield put(userFastUpdate())

    const userData = yield call(services.updatePhoto, { user, url })
    yield put(actions.changeUserPhotoSuccessful(userData))
    yield put(showGenericMessage(payload.url === null ? translation('editUserForm')['removedImage'] : translation('editUserForm')['updatedImage']))
    if (payload.cb) payload.cb()
  } catch (error) {
    yield put(actions.changeUserPhotoFailure(error))
    yield put(userFastRollback())
    yield put(showGenericMessage(translation('editUserForm')['updateImageError']))
    if (payload.cb) payload.cb()
  }
}

export function * changeUserEmail ({ payload }) {
  const { translation, ...rest } = payload
  const oldUser = rest.user
  const newUser = { ...oldUser, email: rest.email }

  const userFastUpdate = () => authActions.getMyDataSuccessful(newUser)
  const userFastRollback = () => authActions.getMyDataSuccessful(oldUser)

  try {
    yield put(userFastUpdate())

    const userData = yield call(services.updateEmail, rest)
    yield put(actions.changeUserEmailSuccessful(userData))
    yield put(showGenericMessage(translation('securityCard')['editEmailSuccess']))
  } catch (error) {
    yield put(actions.changeUserEmailFailure(error))
    yield put(userFastRollback())
    yield put(showGenericMessage(translation('securityCard')['editEmailFailure']))
  }
}

export function * changeUserPassword ({ payload }) {
  const { translation, ...rest } = payload
  try {
    const userData = yield call(services.updatePassword, rest)

    yield put(actions.changeUserPasswordSuccessful(userData))
    yield put(showGenericMessage(translation('securityCard')['editPasswordSuccess']))
  } catch (error) {
    yield put(actions.changeUserPasswordFailure(error))
    yield put(showGenericMessage(translation('securityCard')['editPasswordFailure']))
  }
}

export function * updateUserData ({ payload }) {
  const { user, data, translation } = payload
  const oldUser = user
  const newUser = { ...oldUser,
    name: data.name,
    email: data.email,
    fractal_id: data.fractal_id,
    genre: data.genre,
    birthday: data.birthday,
    phone: data.phone,
    taxpayer_number: data.taxpayer_number,
    additional_data: data.additional_data
  }
  const userFastUpdate = () => authActions.getMyDataSuccessful(newUser)
  const userFastRollback = () => authActions.getMyDataSuccessful(oldUser)
  const appData = getCurrentAppData()
  try {
    yield put(userFastUpdate())
    const userData = yield call(services.updateData, payload)
    yield put(actions.updateUserDataSuccessful(userData))
    yield put(showGenericMessage(translation('editUserForm')['editDataSuccess']))
    if (appData && appData.redirectUrl) {
      window.location.href = appData.redirectUrl
    }
  } catch (e) {
    yield put(actions.updateUserDataFailure(e))
    yield put(userFastRollback())
    yield put(showGenericMessage(translation('editUserForm')['editDataFailure']))
  }
}

// Watchers
export function * watchChangeUserPhoto () {
  yield takeLatest(types.CHANGE_USER_PHOTO, changeUserPhoto)
}

export function * watchChangeUserEmail () {
  yield takeLatest(types.CHANGE_USER_EMAIL, changeUserEmail)
}

export function * watchChangeUserPassword () {
  yield takeLatest(types.CHANGE_USER_PASSWORD, changeUserPassword)
}

export function * watchUserUpdateData () {
  yield takeLatest(types.UPDATE_USER_DATA, updateUserData)
}

export default function * authSagas () {
  yield all([
    watchChangeUserPhoto(),
    watchChangeUserEmail(),
    watchChangeUserPassword(),
    watchUserUpdateData()
  ])
}
